import { Action } from '@ngrx/store'
import * as FormsTypes from './forms.types'
import { Form } from './forms.interface'

export class FetchFormsRequest implements Action {
  readonly type = FormsTypes.FETCH_FORMS_REQUEST
  constructor(public payload: any) {}
}

export class FetchFormsSuccess implements Action {
  readonly type = FormsTypes.FETCH_FORMS_SUCCESS
  constructor(
    public payload: Form[],
    public total: number,
    public filtered: number,
  ) {}
}

export class FetchFormsFailure implements Action {
  readonly type = FormsTypes.FETCH_FORMS_FAILURE
  constructor(public payload: any) {}
}

export class FetchFormRequest implements Action {
  readonly type = FormsTypes.FETCH_FORM_REQUEST
  constructor(public id: number) {}
}

export class FetchFormSuccess implements Action {
  readonly type = FormsTypes.FETCH_FORM_SUCCESS
  constructor(public payload: Form) {}
}

export class FetchFormFailure implements Action {
  readonly type = FormsTypes.FETCH_FORM_FAILURE
  constructor(public payload: any) {}
}

export class DeleteFormRequest implements Action {
  readonly type = FormsTypes.DELETE_FORM_REQUEST
  constructor(public id: number) {}
}

export class DeleteFormSuccess implements Action {
  readonly type = FormsTypes.DELETE_FORM_SUCCESS
  constructor() {}
}

export class DeleteFormFailure implements Action {
  readonly type = FormsTypes.DELETE_FORM_FAILURE
  constructor(public payload: any) {}
}

export class CreateFormRequest implements Action {
  readonly type = FormsTypes.CREATE_FORM_REQUEST
  constructor(public payload, public redirect = true) {}
}

export class CreateFormSuccess implements Action {
  readonly type = FormsTypes.CREATE_FORM_SUCCESS
  constructor() {}
}

export class CreateFormFailure implements Action {
  readonly type = FormsTypes.CREATE_FORM_FAILURE
  constructor(public payload: any) {}
}

export class UpdateFormRequest implements Action {
  readonly type = FormsTypes.UPDATE_FORM_REQUEST
  constructor(public id: number, public payload, public redirect: boolean) {}
}

export class UpdateFormSuccess implements Action {
  readonly type = FormsTypes.UPDATE_FORM_SUCCESS
  constructor() {}
}

export class UpdateFormFailure implements Action {
  readonly type = FormsTypes.UPDATE_FORM_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = FormsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = FormsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateFormRequest
  | UpdateFormSuccess
  | UpdateFormFailure
  | FetchFormsSuccess
  | FetchFormsFailure
  | FetchFormsRequest
  | FetchFormSuccess
  | FetchFormFailure
  | FetchFormRequest
  | CreateFormRequest
  | CreateFormSuccess
  | CreateFormFailure
  | DeleteFormRequest
  | DeleteFormSuccess
  | DeleteFormFailure
  | SetDefaultData
  | UpdateField
